module.exports = __webpack_public_path__ + "images/zelda_rgba(0,0,0,0.7).a58f99040cea114616b55b015a707225.jpg";